<template>
  <div :title="$t('sectionModalNewBudget.newQuoteFarmaFacil')">
    <button class="btn-square btn-success btn-rounded" @click="AbrirModal()">
      <i class="fas fa-shopping-cart"></i>
    </button>

    <b-modal
      v-model="abrir"
      :title="$t('sectionModalNewBudget.newQuote')"
      size="lg"
      hide-footer
    >
      <div class="row">
        <div class="col">
          <label for="">
            {{ $t("sectionModalNewBudget.imageToComposeBudget") }}
          </label>
        </div>
      </div>
      <div v-if="loading" class="loading-container">
        <RotateSquare
          class="loading-position animated fadeIn"
          size="60px"
        ></RotateSquare>
      </div>
      <div v-else>
        <div class="row">
          <div class="col-sm-6">
            <div class="form-group">
              <label for>{{ $t("sectionModalNewBudget.observation") }}</label>
              <b-form-textarea
                v-model="viewModel.observacao"
                rows="15"
                max-rows="15"
              >
              </b-form-textarea>
            </div>
          </div>
          <div class="col-sm-6">
            <div class="form-group">
              <label>
                {{ viewModel.arquivosIds.length }}
                {{ $t("sectionModalNewBudget.imagesSelected") }}
              </label>

              <b-table
                :hover="true"
                responsive
                :items="itens"
                :fields="fields"
                striped
                :per-page="itensPorPaginaFront"
                show-empty
                :empty-text="$t('sectionModalArchive.fileNotFound')"
              >
                <!-- original nome vazio -->
                <!-- <template v-slot:empty="scope">
                  <h4>{{ scope.emptyText }} </h4>
                </template> -->
                <!-- original nome vazio -->

                <template v-slot:cell(nome)="data">
                  <div>
                    <img
                      v-if="data.item.tipo == 5"
                      :src="
                        $store.getters.baseURL + 'arquivo/obter/' + data.item.id
                      "
                      width="50px"
                      height="50px"
                    />
                    <img
                      v-if="data.item.tipo == 4"
                      data-v-70722d2c=""
                      src="../../assets/img/pdfIcon50px.png"
                      margin-left="5px"
                    />
                  </div>
                </template>

                <template v-slot:cell(data)="data">
                  <div class="center">
                    <label for>{{
                      new Date(data.item.data).toLocaleString()
                    }}</label>
                  </div>
                </template>
                <template v-slot:cell(acao)="data">
                  <div class="btn-group-sm">
                    <a
                      class="btn btn-secondary"
                      style="margin-right: 10px;"
                      :href="
                        $store.getters.baseURL + 'arquivo/obter/' + data.item.id
                      "
                      :title="$t('sectionModalArchive.viewFile')"
                      target="_blank"
                    >
                      <i class="fas fa-eye mr-1" style="color: black;"></i>
                    </a>
                    <b-button
                      :variant="ObterCorArquivoSelecionado(data.item.id)"
                      :title="$t('textSelecionar')"
                      @click="SelecionarArquivo(data.item.id)"
                    >
                      <i class="fa fa-check" style="color: black;"></i>
                    </b-button>
                  </div>
                </template>
              </b-table>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <div class="form-group">
              <label>
                {{ $t("sectionModalNewBudget.quoteToBeSavedSomeonePhone") }}
              </label>
              <b-form-checkbox
                v-model="mudarContato"
                name="check-button"
                switch
                :disabled="enumTipoContato==3"
                :title="$t('sectionModalNewBudget.changeContactQuote')"
              >
                {{ $t("textYes") }}
              </b-form-checkbox>
            </div>
          </div>
        </div>
        <div v-if="mudarContato" class="row">
          <div class="col-6">
            <div class="form-group">
              <label for=""
                >* {{ $t("sectionConversas.conversasTelefone") }}</label
              >
              <v-select
                v-model="telefone"
                :placeholder="$t('sectionModalNewBudget.searchPhoneOrName')"
                :options="vSelectContato"
                :multiple="false"
                @search="ObterContato"
              >
                <template slot="no-options">
                  {{ $t("textAguardeNenhumResultado") }}
                </template>
              </v-select>
            </div>
          </div>
          <div class="col-6">
            <div class="form-group">
              <label for="">{{ $t("sectionOrcamento.orcamentoTipoArquivo") }}</label>
              <input v-model="nome" type="text" class="form-control" />
            </div>
          </div>
        </div>
        <div class="d-flex">
          <button
            class="btn btn-success align-self-center mr-2"
            type="submit"
            :title="$t('sectionModalNewBudget.clickToNewQuote')"
            @click="ValidarForm()"
          >
            {{ $t("btEnviar") }}
          </button>
          <button
            class="btn btn-secondary align-self-center"
            type="button"
            @click="Voltar"
          >
            {{ $t("btVoltar") }}
          </button>
          <b-pagination
            v-model="pagina"
            v-on:input="myClickedEventhandlerPagination"
            :total-rows="total"
            :per-page="itensPorPaginaFront"
            size="md"
            class="ml-auto"
          ></b-pagination>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import RotateSquare from "../../components/RotateSquare"
import TipoMensagem from "../../enums/TipoMensagem"

export default {
  name: "ModalNewBudget",
  components: {RotateSquare},
  props: {
    contatoId: {
      type: String,
      default: ""
    },
    telefoneId: {
      type: String,
      default: ""
    },
    atendimentoId: {
      type: String,
      default: ""
    },
    status: {
      type: Number,
      default: 0
    },
    origem: {
      type: Number,
      default: 0
    },
    enumTipoContato:{
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      mudarContato: false,
      telefone: "",
      nome: "",
      loading: false,
      abrir: false,
      itens: [],
      pagina: 1,
      total: 0,
      itensPorPagina: 6,
      itensPorPaginaFront: 6,
      vSelectContato: [],
      viewModel: {
        observacao: "",
        arquivosIds: [],
        origem: this.origem,
        status: this.status,
        contaId: this.$store.getters.getAutenticacao.contaSelecionadaId,
        atendimentoId: this.atendimentoId,
        contatoId: this.contatoId,
        telefoneId: this.telefoneId
      }
    }
  },
  computed: {
    fields() {
      return [
        {
          key: "nome",
          label: this.$t("sectionOrcamento.orcamentoTipoArquivo"),
          sortable: true
        },
        {
          key: "data",
          label: this.$t("sectionOrcamento.orcamentoData"),
          sortable: true
        },
        {
          key: "acao",
          label: this.$t("sectionOrcamento.orcamentoAcao"),
          sortable: false,
          thClass: "center, wd-120-px"
        }
      ]
    }
  },
  methods: {
    myClickedEventhandlerPagination(page) {
      this.itens = []
      this.total = 0
      this.ObterGrid(page, TipoMensagem.Imagem)
      //this.ObterGrid(page, TipoMensagem.Documento)
    },
    Voltar() {
      this.abrir = false
    },
    SelecionarArquivo(arquivoId) {
      if (
        this.viewModel.arquivosIds.filter((x) => x === arquivoId).length > 0
      ) {
        let index = this.viewModel.arquivosIds.indexOf(arquivoId)
        this.viewModel.arquivosIds.splice(index, 1)
      } else this.viewModel.arquivosIds.push(arquivoId)
    },
    ObterCorArquivoSelecionado(arquivoId) {
      if (this.viewModel.arquivosIds.filter((x) => x === arquivoId).length > 0)
        return "success"
      else return "secondary"
    },
    async AbrirModal() {
      this.abrir = true
      // this.itensPorPagina = 3
      this.viewModel.observacao = ""
      this.viewModel.arquivosIds = []
      this.viewModel.origem = this.origem
      this.viewModel.status = this.status
      this.viewModel.contaId = this.$store.getters.getAutenticacao.contaSelecionadaId
      this.viewModel.atendimentoId = this.atendimentoId
      this.viewModel.contatoId = this.contatoId
      this.viewModel.telefoneId = this.telefoneId
      this.mudarContato = false
      this.telefone = ""
      this.nome = ""
      this.vSelectContato = []

      this.itens = []
      this.total = 0

      this.ObterGrid(1, TipoMensagem.Imagem)
      //this.ObterGrid(1, TipoMensagem.Documento)
    },
    async ObterTipoArquivo(tipo) {
      switch (tipo) {
        case TipoMensagem.Audio:
          return this.$t("sectionParametro.parametroAudio")
        case TipoMensagem.Video:
          return this.$t("sectionParametro.parametroVideo")
        case TipoMensagem.Documento:
          return this.$t("sectionParametro.parametroDocumento")
        case TipoMensagem.Imagem:
          return this.$t("sectionParametro.parametroImagem")
        default:
          return this.$t("textNaoIdentificado")
      }
    },
    ObterGrid(pagina, TipoMidia) {
      this.loading = true

      let filtro = {
        Pagina: pagina,
        ContaId: this.$store.getters.getAutenticacao.contaSelecionadaId,
        ContatoId: this.contatoId,
        ItensPorPagina: this.itensPorPagina,
        TelefoneId: this.telefoneId,
        Tipo: TipoMidia, //TipoMensagem.Imagem setamos somente como imagem, pois o FF só saber visualizar imagem
        TipoConversa: this.enumTipoContato
      }
      this.$http({
        url: "/contato/obter-arquivo-grid/",
        data: filtro,
        dataType: "json",
        method: "POST"
      })
        .then((response) => {
          //console.log("itens antes:", this.itens)
          this.loading = false
          this.itens.push(...response.data.itens)
           this.itens.sort(function (a, b) {
	        return (b.data > a.data) ? 1 : ((a.data > b.data) ?  -1 : 0);
        });
          console.log("itens:", this.itens)

          this.total += response.data.total
          // this.pagina = response.data.pagina
          // this.itensPorPagina = response.data.itensPorPagina
          console.log("itens depois:", this.itens)
        })
        .catch((erro) => {
          this.loading = false
          this.$notify({
            data: erro.response.data.erros,
            type: "warn",
            duration: 10000
          })
        })
    },
    NovoContato() {
      let split = this.telefone.label.split("-")
      let tel = split[0]
      let contatoVM = {
        ContaId: this.$store.getters.getAutenticacao.contaSelecionadaId,
        NumeroTelefone: tel,
        Nome: this.nome ? this.nome : tel
      }

      this.$http({
        url: "contato/novo-para-conversa",
        data: contatoVM,
        method: "POST"
      })
        .then((resposta) => {
          this.viewModel.contatoId = resposta.data.contatoId
          this.Novo()
        })
        .catch((erro) => {
          this.$notify({
            data: erro.response.data.erros,
            type: "warn",
            duration: 10000
          })
        })
    },
    ValidarForm() {
      if (this.mudarContato) {
        if (!this.telefone) {
          const provideValidPhone = this.$t("infoMessages.provideValidPhone")
          const checkCountryCodeAndAreaCode = this.$t(
            "infoMessages.checkCountryCodeAndAreaCode"
          )

          this.$notify({
            data: [provideValidPhone, checkCountryCodeAndAreaCode],
            type: "warn",
            duration: 10000
          })
        } else {
          if (this.telefone && this.telefone.id) {
            this.viewModel.contatoId = this.telefone.id
            this.Novo()
          } else {
            this.NovoContato()
          }
        }
      } else {
        this.Novo()
      }
    },
    Novo() {
      this.loading = true
      this.$http({
        url: "/orcamento/novo/",
        data: this.viewModel,
        method: "POST"
      })
        .then(() => {
          this.loading = false
          this.abrir = false

          const quotedCreatedSuccessQuote = this.$t(
            "infoMessages.quotedCreatedSuccessQuote"
          )

          this.$notify({
            data: [quotedCreatedSuccessQuote],
            type: "success",
            duration: 10000
          })
        })
        .catch((erro) => {
          this.loading = false
          this.$notify({
            data: erro.response.data.erros,
            type: "warn",
            duration: 10000
          })
        })
    },
    ObterContato(val) {
      if (!val || val.length <= 3) return

      this.$http({
        url:
          "contato/obter-select2-telefone/" +
          this.$store.getters.getAutenticacao.contaSelecionadaId +
          "/" + false +
          "/" +
          val,
        method: "GET"
      })
        .then((resposta) => {
          if (resposta.data && resposta.data.length > 0)
            this.vSelectContato = resposta.data
          else this.vSelectContato = [{id: "", label: val}]
        })
        .catch((erro) => {
          this.$notify({
            data: erro.response.data.erros,
            type: "warn",
            duration: 10000
          })
        })
    }
  }
}
</script>

<style lang="scss"></style>
